import Client from '@/client'

export default {
  list() {
    return Client.get(`techniques/`)
  },
  create(payload) {
    return Client.post(`techniques/`, payload)
  },
  retrieve(id) {
    return Client.get(`techniques/${id}/`)
  },
  update(id, payload) {
    return Client.put(`techniques/${id}/`, payload)
  },
  delete(id) {
    return Client.delete(`techniques/${id}/`)
  }
}